<div class="container">
    <div class="single-column-layout">
        <h1>Agents</h1>

        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Address</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (agent of agents; track agent) {
                    <tr (mouseenter)="agent.hover = true" (mouseleave)="agent.hover = false">
                        <td>
                            @if (!isEditMode(agent)) {
                                <span>{{ agent.name }}</span>
                            }
                            @if (isEditMode(agent)) {
                                <input id="agentName"
                                       type="text"
                                       maxlength="50"
                                       placeholder="Name"
                                       class="form-control"
                                       [(ngModel)]="agentInEdit.name"
                                       required>
                            }
                        </td>
                        <td>
                            @if (!isEditMode(agent)) {
                                <span>{{ agent.company }}</span>
                            }
                            @if (isEditMode(agent)) {
                                <input type="text"
                                       maxlength="50"
                                       placeholder="Company"
                                       class="form-control"
                                       [(ngModel)]="agentInEdit.company">
                            }
                        </td>
                        <td [style.width]="isEditMode(agent) ? '300px' : 'initial'">
                            <address-view-edit [address]="isEditMode(agent) ? agentInEdit.address : agent.address"
                                               [isEditMode]="isEditMode(agent)"></address-view-edit>
                        </td>
                        <td style="width: 70px;">
                            @if (hasEditPermission) {
                                <div class="agent-action-buttons">
                                    @if (!agentInEdit) {
                                        <div class="d-flex" [class.invisible]="!agent.hover">
                                            <button class="ace-btn has-icon btn-primary mb-0"
                                                    (click)="goToEditMode(agent)">
                                                <i class="fa fa-pencil"></i></button>
                                            <button class="ace-btn has-icon btn-primary btn-danger mb-0"
                                                    (click)="confirmDeleteAgent(agent)">
                                                <i class="fa fa-trash"></i></button>
                                        </div>
                                    }
                                    @if (isEditMode(agent)) {
                                        <div class="d-flex">
                                            <button class="ace-btn has-icon btn-primary mb-0"
                                                    (click)="saveAgent()"
                                                    [disabled]="!agentInEdit.name">
                                                <i class="fa fa-save"></i></button>
                                            <button class="ace-btn has-icon btn-primary btn-danger mb-0"
                                                    (click)="cancelEdit()">
                                                <i class="fa fa-times"></i></button>
                                        </div>
                                    }
                                </div>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>

        @if (!agentInEdit && hasEditPermission) {
            <div style="text-align: right;">
                <button class="ace-btn btn-primary" (click)="addNew()">Add New</button>
            </div>
        }
    </div>
</div>
